import axios from 'axios'

const URL_PATH = 'api/pedido/documentos/anexo'
class AnexoApiClient {
	async buscarAnexosPorDocumentoId(idDocumento) {
		const { data } = await axios.get(`${URL_PATH}/${idDocumento}`)
		return data
	}
	async adicionarAnexo(documentoComAnexo) {
		return await axios.post(`${URL_PATH}`, documentoComAnexo)
	}
}

export default new AnexoApiClient()
